import { useSelector } from 'react-redux';
import { selectSettings } from '@/store/bootstrap/selectors';
import { useKFlags } from '@/hooks/use-k-flags';

export const useIntegrations = () => {
  const settingsDetails = useSelector(selectSettings);
  // SpringVerify is behind the `fe-springverify` LaunchDarkly flag while it
  // rolls out — gate the account connection here so every consumer
  // (send-assessment action, background-check card) is hidden when it's off.
  const { feSpringverify } = useKFlags();

  return {
    isHackerRankEnabled: settingsDetails?.account?.connected_hackerrank,
    isHackerEarthEnabled: settingsDetails?.account?.connected_hackerearth,
    isCriteriaCorpEnabled: settingsDetails?.account?.connected_criteriacorp,
    isCheckrEnabled: settingsDetails?.account?.connected_checkr,
    isCertnEnabled: settingsDetails?.account?.connected_certn,
    isZincEnabled: settingsDetails?.account?.connected_zinc,
    isSpringVerifyEnabled: Boolean(
      feSpringverify && settingsDetails?.account?.connected_springverify
    ),
    isHireflixEnabled: settingsDetails?.account?.connected_hireflix,
    isCodeInterviewEnabled: settingsDetails?.account?.connected_codeinterview,
  };
};
